/**
 * `@drang/sdk` — what plugins import (design spec §9.10). The host exposes this module through the
 * import map, so a plugin bundle shares the host's React instance, registries, hooks and UI primitives.
 * Everything a plugin may rely on is exported here; anything else is internal and may change.
 */
export const SDK_VERSION = "1";

export {
  registerViewType,
  getViewType,
  listViewTypes,
  type ViewType,
  type ViewProps,
  type ViewCtx,
} from "../registry/viewTypes";
export {
  registerTaskType,
  getTaskType,
  listTaskTypes,
  type TaskType,
  type TaskTypeCtx,
} from "../registry/taskTypes";

// doc access
export { useDocSelector, useDoc, useDocState } from "../core/useDocSelector";
export { useNow } from "../core/useNow";
export { listTasks, readTask, parentOf, childrenOf } from "../core/tasks";
export { matches, type FilterAst } from "../core/filter";
export { computeAll, COMPUTED_KEYS } from "../core/computed";
export { want, wantLevel, wantDisplay } from "../core/want";
export { Snapshot, blocked, active, groupsOf, sequencesOf } from "../core/structure";
export { visibleTasks, filterCtx } from "../views/shared";
export * as ops from "../core/ops";
export { completeTask, uncompleteTask } from "../core/complete";
export type { Task, PropDef, PropVal, Level } from "../core/schema";

// UI primitives (docs/FRONTEND_DESIGN.md) — plugins consume tokens through these, never hex values
export * as ui from "../ui";
export { WantBar } from "../tasks/WantBar";

// i18n: plugins ship their own `locales/` and register a namespace
import i18n from "../i18n";
export function registerLocales(namespace: string, resources: Record<string, Record<string, unknown>>): void {
  for (const [lang, res] of Object.entries(resources))
    i18n.addResourceBundle(lang, namespace, res, true, true);
}
export { useTranslation } from "react-i18next";
